import { render } from "./searchClubs.vue?vue&type=template&id=39132bc6"
import script from "./searchClubs.vue?vue&type=script&lang=js"
export * from "./searchClubs.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__